import * as React from 'react';

import SimpleviewForm from 'components/SimpleviewForm';
import useLiveData from 'hooks/useLiveData';
import { useStaticQuery, graphql } from 'gatsby';

const SimpleviewFormProvider = (props) => {
	const data = useStaticQuery(graphql`
		query simpleviewForms {
		  allSmartTagsSimpleviewForm {
		    edges {
		      node {
		        id
		        formID
		        hijackSubmission
		        submissionRedirect
		        submissionMessage
		      }
		    }
		  }
		}
	`);
	const {response} = useLiveData({
		namespace: 'SmartTags',
		model: 'SimpleviewForm',
		method: 'all',
		staticData: data,
		graphqlKey: 'allSmartTagsSimpleviewForm',
	});
	if (response.data.length === 0)return null;
	let attr;
	for (let item of response.data) {
		if (item.id === props.id)attr = item;
	}
	if (!attr)return null;
	return <SimpleviewForm {...attr} />
}

export default SimpleviewFormProvider;